import PageHeader from "../../Organisms/PageHeader/PageHeader";
import MenuVertical from "../../Organisms/MenuVertical/MenuVertical";
import "./AppLayout.scss";
import { useContext } from "react";
import MenuContext from "../../../context/MenuContext";
import { breakPointMenuFixed } from "../../../services/variants/config";

export const AppLayout = ({ children }) => {
  const { isMenuOpen } = useContext(MenuContext)
  const viewportWidh = window.innerWidth

  return (
    <div>
      <PageHeader />
      <div className="s-hidden m-show">
         <MenuVertical />
      </div>
      <main className={`geniux-content ${isMenuOpen && viewportWidh >= breakPointMenuFixed ? 'active' : ''}`}> {children} </main>
    </div>
  );
};
